module.exports = __webpack_public_path__ + "media/images/iconUp__errorRed-86e80951fc376b44ba5dcb9b4bed623f.png";